import { useEffect } from 'react';
import { useSearchParam } from '@hooks/useSearchParam';
import { usePersistedState } from '@hooks/persist/usePersistedState';
import { SearchParam, STORAGE_KEYS, StorageType } from '@constants/common';

// Persists an autotest flag into sessionStorage when the URL carries the
// is_autotest query param, and exposes it so consumers (e.g. onboarding
// tooltips) can opt out of interactive UI during automated test runs.
export const useAutoTest = () => {
  const { param } = useSearchParam(SearchParam.IS_AUTO_TEST);
  const [isAutoTest, setIsAutoTest] = usePersistedState(
    STORAGE_KEYS.IS_AUTO_TEST,
    false,
    StorageType.SESSION
  );

  useEffect(() => {
    if (!param) {
      return;
    }

    setIsAutoTest(true);
  }, [param, setIsAutoTest]);

  return { isAutoTest };
};
